import { useForm } from "react-hook-form";
import { makeStyles } from "tss-react/mui";
import { MiContentDrawer, MiDetailFields } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { mdiShieldAccountVariant } from "@mdi/js";

const initialData = {
  name: "",
  description: "",
  permissionNames: [],
};

export function AddRoleDrawer({ onClose, onSubmit, loading, ...rest }) {
  const {
    handleSubmit,
    control,
    reset,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: initialData,
  });
  const { classes } = useStyles();

  const userFields = [
    {
      label: "Role Name",
      name: "name",
      formControl: control,
      required: true,
      width: "100%",
    },
    {
      label: "Description",
      name: "description",
      formControl: control,
      multiline: true,
      required: true,
      width: "100%",
    },
  ];

  const handleDrawerClose = () => {
    onClose();
    reset();
  };

  return (
    <MiContentDrawer
      title="Add Role"
      variant="temporary"
      leftIcon={mdiShieldAccountVariant}
      isLoading={loading}
      onClose={handleDrawerClose}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          size: "medium",
          color: BUTTON_COLORS.BLACK,
          onClick: handleDrawerClose,
        },
        {
          name: "Submit",
          variant: BUTTON_VARIANTS.CONTAINED,
          size: "medium",
          color: BUTTON_COLORS.PRIMARY,
          disabled: !isValid || loading,
          onClick: handleSubmit(onSubmit),
        },
      ]}
      topRightClose={handleDrawerClose}
      {...rest}
    >
      <MiDetailFields
        detailFields={userFields}
        control={control}
        containerStyle={classes.container}
      />
    </MiContentDrawer>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(3),
    width: "100%",
  },
}));
